import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import Immutable from 'immutable';
import Content from '../../../layout/Content';
import { CABIN_CREW_MOVEMENT_HISTORY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import CabinCrewMovementHistoryBasicResource from './CabinCrewMovementHistoryBasicResource';
import CabinCrewMovementHistoryPrintButton from './CabinCrewMovementHistoryPrintButton';
import EditButton from '../../../common/button/EditButton';
import DeleteCabinCrewMovementHistoryButton from './DeleteCabinCrewMovementHistoryButton';
import { clearCabinCrewMovementHistory, getCabinCrewMovementHistory } from '../../../../actions';

const CabinCrewMovementHistory = ({
  match: {
    params: { id },
  },
  dispatchGetCabinCrewMovementHistory,
  dispatchClearCabinCrewMovementHistory,
  loading,
  cabinCrewMovementHistory,
  breadcrumbs,
}) => {
  useLayoutEffect(() => {
    dispatchGetCabinCrewMovementHistory({ cabinCrewMovementHistoryId: id });
    return () => dispatchClearCabinCrewMovementHistory();
  }, []);
 
  let content;

  let toolbar;

  if (loading) content = <Loader />;
  else if (cabinCrewMovementHistory.isEmpty())
    content = <NoDataResource returnPage={CABIN_CREW_MOVEMENT_HISTORY_PATH} />;
  else {
    const cabinCrewMovementHistoryJson = cabinCrewMovementHistory.toJS();
    toolbar = (
      <ButtonToolbar className="pull-right">
        <DeleteCabinCrewMovementHistoryButton cabinCrewMovementHistoryId={id} />{' '}
        <EditButton
          path={`${CABIN_CREW_MOVEMENT_HISTORY_PATH}/${cabinCrewMovementHistoryJson.id}/edit`}
        />
        <CabinCrewMovementHistoryPrintButton {...cabinCrewMovementHistoryJson} />
      </ButtonToolbar>
    );
    content = (
      <CabinCrewMovementHistoryBasicResource {...cabinCrewMovementHistoryJson} />
    );
  }
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Historial de movimiento de servicio a bordo"
      subtitle="Historial de movimiento de servicio a bordo"
      content={content}
      toolbar={toolbar}
    />
  );
};

CabinCrewMovementHistory.propTypes = {
  dispatchGetCabinCrewMovementHistory: PropTypes.func.isRequired,
  dispatchClearCabinCrewMovementHistory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  cabinCrewMovementHistory: PropTypes.instanceOf(Immutable.Map).isRequired,
  match: matchPropTypes.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

CabinCrewMovementHistory.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Movimientos de servicio a bordo',
      href: CABIN_CREW_MOVEMENT_HISTORY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  cabinCrewMovementHistory: TrafficUnit.CabinCrewMovementHistory.getIn([
    'current',
    'content',
  ]),
  loading: !TrafficUnit.CabinCrewMovementHistory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetCabinCrewMovementHistory: getCabinCrewMovementHistory,
  dispatchClearCabinCrewMovementHistory: clearCabinCrewMovementHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CabinCrewMovementHistory);